import React, { useState } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const PrivacyPolicy = () => {
  const [activeTab, setActiveTab] = useState(0);

  const containerStyle = {
    maxWidth: '1100px',
    margin: '0 auto',
    padding: '20px',
    fontFamily: "'Poppins', sans-serif",
    color: '#2d3436',
    backgroundColor: '#ffffff',
    minHeight: '100vh'
  };

  const headerStyle = {
    textAlign: 'center',
    padding: '40px 20px',
    background: 'linear-gradient(135deg, #6a89cc 0%, #4a69bd 100%)',
    borderRadius: '12px',
    marginBottom: '30px',
    color: 'white',
    boxShadow: '0 10px 20px rgba(74, 105, 189, 0.3)'
  };

  const titleStyle = {
    fontSize: '2.8rem',
    fontWeight: '700',
    marginBottom: '10px',
    letterSpacing: '0.5px'
  };

  const subtitleStyle = {
    fontSize: '1.2rem',
    fontWeight: '300',
    opacity: '0.9',
    maxWidth: '700px',
    margin: '0 auto'
  };

  const tabContainerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    marginBottom: '30px',
    justifyContent: 'center'
  };

  const tabStyle = {
    padding: '12px 24px',
    borderRadius: '30px',
    cursor: 'pointer',
    fontWeight: '600',
    transition: 'all 0.3s ease',
    backgroundColor: '#dfe6e9',
    color: '#636e72'
  };

  const activeTabStyle = {
    ...tabStyle,
    backgroundColor: '#6a89cc',
    color: 'white',
    boxShadow: '0 4px 8px rgba(106, 137, 204, 0.4)'
  };

  const contentStyle = {
    backgroundColor: '#f8f9fa',
    borderRadius: '12px',
    padding: '30px',
    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.08)'
  };

  const sectionTitleStyle = {
    fontSize: '1.8rem',
    fontWeight: '600',
    color: '#2d3436',
    marginBottom: '20px',
    paddingBottom: '10px',
    borderBottom: '2px solid #6a89cc'
  };

  const textStyle = {
    fontSize: '1rem',
    lineHeight: '1.7',
    marginBottom: '20px',
    color: '#2d3436'
  };

  const listStyle = {
    paddingLeft: '20px',
    marginBottom: '20px'
  };

  const listItemStyle = {
    marginBottom: '12px',
    position: 'relative',
    paddingLeft: '20px'
  };

  const listIconStyle = {
    position: 'absolute',
    left: '0',
    color: '#6a89cc',
    fontWeight: 'bold'
  };

  const highlightBoxStyle = {
    backgroundColor: '#e8f4f8',
    borderLeft: '4px solid #6a89cc',
    borderRadius: '8px',
    padding: '20px',
    margin: '25px 0'
  };

  const contactGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '20px',
    marginTop: '40px'
  };

  const contactCardStyle = {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '25px',
    textAlign: 'center',
    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)',
    transition: 'transform 0.3s ease',
    cursor: 'pointer'
  };

  const contactIconStyle = {
    fontSize: '2.5rem',
    marginBottom: '15px',
    color: '#6a89cc'
  };

  const policySections = [
    {
      title: "Introduction",
      content: (
        <div>
          <p style={textStyle}>
            At <strong>SURYAWANSHI WATCH & OPTICIANS</strong>, we prioritize your privacy and are committed to protecting your personal information. 
            This Privacy Policy explains how we collect, use, and safeguard your data when you interact with our website, 
            purchase our products, or use our optometry services.
          </p>
          <p style={textStyle}>
            By using our website and services, you consent to the practices described in this policy. 
            We encourage you to read this document carefully to understand our approach to privacy.
          </p>
        </div>
      )
    },
    {
      title: "Data Collection",
      content: (
        <div>
          <p style={textStyle}>
            We collect information to provide better services to our customers:
          </p>
          <ul style={listStyle}>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> <strong>Account Information:</strong> Name, email, phone number, shipping address</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> <strong>Payment Details:</strong> Credit card information, billing address (processed securely)</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> <strong>Vision Prescription Data:</strong> For custom eyewear orders</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> <strong>Device Information:</strong> IP address, browser type, device characteristics</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> <strong>Usage Data:</strong> How you interact with our website and products</li>
          </ul>
          <div style={highlightBoxStyle}>
            <strong>Note:</strong> We treat vision prescription data with extra care, following all applicable healthcare privacy regulations.
          </div>
        </div>
      )
    },
    {
      title: "Data Usage",
      content: (
        <div>
          <p style={textStyle}>
            How we use your information:
          </p>
          <ul style={listStyle}>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Process orders and deliver products</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Create custom eyewear based on your prescription</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Provide customer support and respond to inquiries</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Send order updates and service notifications</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Improve our website, products, and services</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Prevent fraud and enhance security measures</li>
          </ul>
        </div>
      )
    },
    {
      title: "Data Protection",
      content: (
        <div>
          <p style={textStyle}>
            We implement robust security measures to protect your information:
          </p>
          <ul style={listStyle}>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> SSL encryption for all data transmissions</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Secure storage with limited access</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Regular security audits and updates</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Payment information processed by PCI-compliant partners</li>
          </ul>
          <div style={highlightBoxStyle}>
            <strong>Health Data Protection:</strong> Vision prescription data receives additional protection 
            in compliance with healthcare privacy regulations.
          </div>
        </div>
      )
    },
    {
      title: "Your Rights",
      content: (
        <div>
          <p style={textStyle}>
            You have the following rights regarding your personal data:
          </p>
          <ul style={listStyle}>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Access and receive a copy of your data</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Correct inaccurate information</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Request deletion of your data</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Object to or restrict processing</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Data portability</li>
            <li style={listItemStyle}><span style={listIconStyle}>•</span> Withdraw consent at any time</li>
          </ul>
          <p style={textStyle}>
            To exercise any of these rights, please contact us using the information below.
          </p>
        </div>
      )
    }
  ];

  return (
    <>
    <Navbar />
    <div style={containerStyle}>
      <div style={headerStyle}>
        <h1 style={titleStyle}>Privacy Policy</h1>
        <p style={subtitleStyle}>
          We value your privacy and are transparent about how we handle your personal information
        </p>
      </div>

      <div style={tabContainerStyle}>
        {policySections.map((section, index) => (
          <div 
            key={index}
            style={activeTab === index ? activeTabStyle : tabStyle}
            onClick={() => setActiveTab(index)}
          >
            {section.title}
          </div>
        ))}
      </div>

      <div style={contentStyle}>
        <h2 style={sectionTitleStyle}>{policySections[activeTab].title}</h2>
        {policySections[activeTab].content}
      </div>

      <div style={contactGridStyle}>
        <div style={contactCardStyle}>
          <div style={contactIconStyle}>📧</div>
          <h3>Email Us</h3>
          <p>suryawanshiwatch1918@gmail.com</p>
          <p>We typically respond within 24 hours</p>
        </div>
        
        <div style={contactCardStyle}>
          <div style={contactIconStyle}>📞</div>
          <h3>Call Us</h3>
          <p>+91 79729 64344</p>
          <p>Mon-Fri, 9AM-6PM</p>
        </div>
        
        <div style={contactCardStyle}>
          <div style={contactIconStyle}>📝</div>
          <h3>Mail Us</h3>
          <p>SURYAWANSHI WATCH & OPTICIANS</p>
          <p>Station Road, Near Rajwada
Tasgaon 416312, (Sangli)
India</p>
        </div>
      </div>
    </div>
    <Footer />
    </>
  );
};

export default PrivacyPolicy;